// src/pages/AuthPopupBridge.tsx
//
// This is used for the xero connect so we validate the user first
// we could refactor this to be used for verify and link too
//
import { Box, CircularProgress, Typography } from '@mui/material';
import { FC, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiClient } from '../../services';
import { OAuthActionType } from '@avanzu/types';
import { useAuth } from '../../contexts/AuthContext';

export const AuthPopupBridge: FC = () => {
  const { organisationId } = useAuth();
  const [statusMessage, setStatusMessage] = useState('Connecting to Xero...');
  const [searchParams] = useSearchParams();
  const hasExecuted = useRef(false);

  const handleAuthConnect = async (organisationId: string, searchParamsString: string) => {
    try {
      const endpoint = `/auth/oauth/xero/organisation/${organisationId}/connect?${searchParamsString}`;
      const response = await apiClient.request(endpoint, { method: 'GET', redirect: 'manual' });

      if (response.status === 200) {
        const data = await response.json();
        const redirectUrl = data.url;
        if (redirectUrl) {
          window.location.href = redirectUrl;
          return;
        } else {
          throw new Error('Server redirect error, no URL provided.');
        }
      }
    } catch (err: any) {
      console.error('Error during Xero connect:', err);
      setStatusMessage(`Connection failed: ${err.message || 'Unknown error occurred.'}`);
    }
  };

  // Execute immediately on component mount, only once
  if (!hasExecuted.current && organisationId) {
    hasExecuted.current = true;

    const action: OAuthActionType = searchParams.get('action') as OAuthActionType;

    switch (action) {
      case OAuthActionType.CONNECT:
        handleAuthConnect(organisationId, searchParams.toString());
        break;
      default:
        setStatusMessage('Invalid action specified.');
        break;
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ bgcolor: 'background.default' }}
    >
      <CircularProgress size={48} />
      <Typography
        variant="body1"
        sx={{
          mt: 2,
          color: 'text.secondary',
          textAlign: 'center',
        }}
      >
        {statusMessage}
      </Typography>
    </Box>
  );
};

export default AuthPopupBridge;
